class PlotLine {

	constructor(name) {
		this.config = {
			x: 0,
			label: null,
			name
		};
	}

	x(x) {
		this.config.x = x;
		return this;
	}

	label(label) {
		this.config.label = label;
		return this;
	}

}

export function plotLine(name) {
	return new PlotLine(name);
}



// WEBPACK FOOTER //
// ./utils/panelgraph/components/plot-line.js